import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

export interface PlanRefuerzoComportamiento {
  id?: number;
  id_evaluacion: number;
  accion: string;
  responsable?: string | null;
  fecha_compromiso: string;
  fecha_cumplimiento?: string | null;
  estado_avance?: number | null;
  observaciones?: string | null;
  estado?: number;
}

@Injectable({ providedIn: "root" })
export class PlanRefuerzoComportamientoService {
  private readonly baseUrl = `${environment.apiUrl}/api/plan_refuerzo_comportamiento`;

  constructor(private http: HttpClient) {}

  getAllByEvaluacion(idEvaluacion: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/evaluacion/${idEvaluacion}`);
  }

  create(payload: PlanRefuerzoComportamiento): Observable<any> {
    return this.http.post(this.baseUrl, payload);
  }

  update(id: number, payload: Partial<PlanRefuerzoComportamiento>): Observable<any> {
    return this.http.put(`${this.baseUrl}/${id}`, payload);
  }

  activar(id: number): Observable<any> {
    return this.http.put(`${this.baseUrl}/${id}/activar`, {});
  }

  inactivar(id: number): Observable<any> {
    return this.http.put(`${this.baseUrl}/${id}/inactivar`, {});
  }
}